/* Component Dependencies */
var moreActivitiesTemplate = require('templates/moreActivities.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'moreActivities',
  template: {
    'moreActivities': moreActivitiesTemplate
  }
});